import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import React, {useEffect} from 'react';
import useError from "../hooks/useError";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function CustomAlertDialog() {
    const [open, setOpen] = React.useState(false);
    const { error, setError } = useError();

    function handleClickOpen() {
        setOpen(true);
    }

    async function handleClose() {
        await setError({title: "", message: "", status: 200});
        setOpen(false);
    }
    useEffect(() => {
        if(error) {
            if (error?.status !== 200) {
                handleClickOpen(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);


    return (
        <div>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                TransitionComponent={Transition}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                style={{zIndex: 10000}}
            >
                <DialogTitle id="alert-dialog-slide-title">{error?.title}</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {error?.message}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
